/* Charma: farebne kruzky Strieborna / Zlata */
(function () {
if (window.__charmaSwatches) return;
window.__charmaSwatches = true;
document.addEventListener('click', function (e) {
var dot = e.target.closest('.charma-sw__dot');
if (!dot) return;
e.preventDefault();
e.stopPropagation();
var card = dot.closest('.card-wrapper') || dot.closest('li') || document;
dot.parentElement.querySelectorAll('.charma-sw__dot').forEach(function (d) {
var on = d === dot;
d.classList.toggle('is-active', on);
d.setAttribute('aria-checked', on ? 'true' : 'false');
});
var img = card.querySelector('.card__media img');
if (img && dot.dataset.img) {
img.removeAttribute('srcset');
img.src = dot.dataset.img;
}
card.querySelectorAll('.card__media img').forEach(function (x, i) { if (i > 0) x.style.display = 'none'; });
card.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function (p) { p.textContent = dot.dataset.price; });
card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.href = dot.dataset.url; });
card.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = dot.dataset.variantId; });
card.querySelectorAll('select').forEach(function (sel) {
var opt = Array.prototype.find.call(sel.options, function (o) {
return o.value === dot.dataset.variantId || o.text.trim().indexOf(dot.dataset.option) === 0;
});
if (opt && sel.value !== opt.value) {
sel.value = opt.value;
sel.dispatchEvent(new Event('change', { bubbles: true }));
}
});
}, true);
function syncLegends() {
document.querySelectorAll('variant-radios fieldset').forEach(function (fs) {
var checked = fs.querySelector('input[name="Farba"]:checked');
var legend = fs.querySelector('legend');
if (checked && legend) legend.textContent = 'Farba: ' + checked.value;
});
}
document.addEventListener('change', function (e) {
if (e.target.matches && e.target.matches('input[name="Farba"]')) syncLegends();
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncLegends); else syncLegends();
})();
